import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import { Typography, TextField } from "@material-ui/core/";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import ProgressBar from "./ProgressBar";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import "../styles/main.css";

const theme = createMuiTheme({
  direction: "rtl"
});

const StyledTitle = withStyles({
  root: {
    fontSize: "20px",
    letterSpacing: 0,
    color: "#EAEAEA",
    opacity: 1,
    lineHeight: "1.7rem",
    align: "left",
    marginBottom: "16px"
  }
})(Typography);

const StyledTextField = withStyles({
  root: {
    width: "100%",
    height: "48px",
    padding: "0px",
    dir: "rtl",
    opacity: 1,
    borderRadius: "4px",
    marginBottom: "24px",
    "& label": {
      color: "#EAEAEA",
      fontSize: "14px"
    },

    "& label.Mui-focused": {
      color: "#EAEAEA",
      fontSize: "14px"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #E5E5E5",
        opacity: 1,
        padding: "0px",
        backgroundColor: "#151515"
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #E5E5E5"
      },
      padding: "0px",
      height: "48px"
    }
  }
})(TextField);

const StyledButtonNext = withStyles({
  root: {
    display: "flex",
    height: "48px",
    background: "#32C6A9 0% 0% no-repeat padding-box",
    borderRadius: "4px",
    opacity: 1,
    fontSize: "18px",
    fontWeight: "bold",

    "&:hover": {
      backgroundColor: "#32C6A9",
      boxShadow: "none"
    },
    "&:active": {
      backgroundColor: "#4A4547",
      boxShadow: "none"
    }
  }
})(Button);

const StyledFormControl = withStyles({
  root: {
    display: "flex",
    marginBottom: "20px",

    "& label": {
      fontSize: "16px"
    },

    "& label.Mui-focused": {
      fontSize: "16px"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #E5E5E5",
        padding: "0px",
        backgroundColor: "#151515"
      },
      "&.Mui-focused fieldset": {
        border: "2px solid #E5E5E5",
        paddingTop: "20px",
        color: "#EAEAEA"
      },
      padding: "0px",
      height: "48px"
    }
  }
})(FormControl);

export class FirstPage extends Component {
  state = {
    buttonEnable: this.props.couponCodeIsValid
  };

  saveToLocalStorage = () => {
    this.props.saveToLocalStorage();
  };

  continue = async e => {
    e.preventDefault();

    await this.props.checkCouponCode();
  };

  render() {
    const {
      values,
      handleChangeName,
      handleChangePhoneNumber,
      handleChangeClassValues,
      handleChangeSubClassValues,
      handleChangeHotCode,
      cancel
    } = this.props;

    let modalMessage;
    switch (this.props.couponCodeStatus) {
      case "false":
        modalMessage = "הקוד שהכנסת אינו תקף";
        break;
      case "used":
        modalMessage = "אין אפשרות להשתמש בקוד פעם נוספת";
        break;
      default:
        modalMessage = "";
        break;
    }

    return (
      <React.Fragment>
        <Grid container spacing={0}>
          <Grid item xs={4}>
            <img
              className="pageImg"
              src={require("../assets/carousel-img/Page1-HotApp.png")}
              title="first page"
              alt="pic"
            />
          </Grid>
          <Grid item xs={8}>
            <div style={{ direction: "rtl" }}>
              <ProgressBar currStep={this.props.currStep} />
            </div>
            <form onSubmit={this.continue} className="page-form">
              <div className="main-content">
                <div className="wrapper" dir="rtl">
                  <StyledTitle variant="h6" display="block" gutterBottom>
                    פרטים אישיים
                  </StyledTitle>

                  <ThemeProvider theme={theme}>
                    <StyledTextField
                      autoFocus
                      required={true}
                      label="שם מלא*"
                      variant="outlined"
                      value={values.fullName}
                      style={{ color: "red !important" }}
                      onChange={e => handleChangeName(e)}
                    ></StyledTextField>
                  </ThemeProvider>

                  <ThemeProvider theme={theme}>
                    <StyledTextField
                      inputMode="numeric"
                      pattern="[0-9]*"
                      error={this.props.invalidPhone ? true : false}
                      required={true}
                      label="הכנס את מספר הטלפון של התלמיד*"
                      variant="outlined"
                      value={values.phoneNumber}
                      onChange={e => handleChangePhoneNumber(e)}
                    ></StyledTextField>

                    <p className="error-phone-text">
                      {this.props.invalidPhone ? "מספר לא תקין" : " "}
                    </p>
                  </ThemeProvider>

                  <ThemeProvider theme={theme}>
                    <StyledFormControl required variant="outlined">
                      <Select
                        native
                        value={values.classSelection}
                        onChange={e => handleChangeClassValues(e)}
                        style={{ fontSize: "14px", color: "#4A4547" }}
                      >
                        <option
                          disabled
                          value={""}
                          style={{
                            display: "none"
                          }}
                        >
                          בחר כיתה*
                        </option>
                        {this.props.classValues.map(val => (
                          <option
                            className="select-option"
                            key={val}
                            value={val}
                            style={{
                              borderBottom: "1px solid #E5E5E5"
                            }}
                          >
                            {val}
                          </option>
                        ))}
                      </Select>
                    </StyledFormControl>
                  </ThemeProvider>

                  {this.props.classSubValues.length > 0 ? (
                    <ThemeProvider theme={theme}>
                      <StyledFormControl required variant="outlined">
                        <Select
                          native
                          value={values.classSubSelection}
                          onChange={e => handleChangeSubClassValues(e)}
                          style={{ fontSize: "14px", color: "red" }}
                        >
                          <option
                            disabled
                            value={""}
                            style={{
                              borderBottom: "1px solid #E5E5E5",
                              display: "none"
                            }}
                          >
                            בחר רמת כיתה
                          </option>
                          {this.props.classSubValues.map(val => (
                            <option
                              className="select-option"
                              key={val}
                              value={val}
                              style={{
                                borderBottom: "1px solid #E5E5E5",
                                backgroundClip: "red"
                              }}
                            >
                              {val}
                            </option>
                          ))}
                        </Select>
                      </StyledFormControl>
                    </ThemeProvider>
                  ) : null}

                  <ThemeProvider theme={theme}>
                    <StyledTextField
                      required={true}
                      label="הזינו את הקופון שקיבלתם מ- HOT*"
                      variant="outlined"
                      value={values.hotCode}
                      onChange={e => handleChangeHotCode(e)}
                    ></StyledTextField>
                  </ThemeProvider>
                </div>
              </div>

              {this.props.openMessageModal ? (
                <div id="myModal" className="modal">
                  <div className="modal-content">
                    <p>{modalMessage}</p>
                    <button
                      onClick={this.props.handleModalClose}
                      className="modal-close"
                    >
                      סגור
                    </button>
                  </div>
                </div>
              ) : null}

              <div
                className="button-container"
                dir="ltr"
                style={{
                  justifyContent: "flex-start",
                  width: "calc(100%-174px)"
                }}
              >
                <StyledButtonNext
                  color="secondary"
                  style={{
                    backgroundImage:
                      "linear-gradient(to right, #FF2D96 , #FF0B13)"
                  }}
                  variant="contained"
                  type="submit"
                >
                  <i
                    className="material-icons"
                    style={{
                      fontSize: "32px",
                      marginRight: "5px",
                      marginLeft: "-12px"
                    }}
                  >
                    keyboard_arrow_left
                  </i>
                  המשך
                </StyledButtonNext>
                <div
                  className="button-cancel"
                  variant="contained"
                  onClick={cancel}
                  style={{ marginLeft: "13%" }}
                >
                  לבטל
                </div>
              </div>
            </form>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default FirstPage;
